{
  "meta": {
    "title": "Ad Campaigns",
    "manageAndTrack": "Manage ad campaigns and track their performance"
  },
  "actions": {
    "addCampaign": "Add Campaign",
    "view": "View",
    "edit": "Edit",
    "cancel": "Cancel",
    "createCampaign": "Create Campaign",
    "creating": "Creating...",
    "payForCampaign": "Pay for Campaign",
    "paying": "Paying...",
    "actions": "Actions"
  },
  "filters": {
    "statusRunning": "Running",
    "statusEnded": "Ended",
    "allStatuses": "All statuses"
  },
  "status": {
    "DRAFT": "Draft",
    "PENDING_PAYMENT": "Awaiting payment",
    "PENDING_APPROVAL": "Awaiting approval",
    "REJECTED": "Rejected",
    "ACTIVE": "Running",
    "PAUSED": "Paused",
    "ENDED": "Ended",
    "CANCELLED": "Cancelled"
  },
  "lifecycle": {
    "created": "Created",
    "paid": "Paid",
    "approved": "Approved",
    "live": "Live",
    "ended": "Ended"
  },
  "table": {
    "image": "Image",
    "name": "Campaign",
    "service": "Service",
    "plan": "Plan",
    "status": "Status",
    "na": "N/A",
    "searchPlaceholder": "Search campaigns...",
    "emptyTitle": "No Campaigns",
    "emptyDescription": "Create a campaign to start promoting your services.",
    "loadFailed": "Failed to load campaigns"
  },
  "create": {
    "title": "Create Ad Campaign",
    "description": "Create a new campaign to promote your services",
    "cardTitle": "Campaign Information",
    "cardDescription": "Add the campaign creative, select a service, plan, and start date",
    "nameLabel": "Campaign name",
    "namePlaceholder": "Optional display name",
    "creativeLabel": "Campaign creative",
    "creativeHelp": "Upload your own image or video, or generate one with AI",
    "creativeTabs": {
      "upload": "Upload from device",
      "generate": "Generate with AI"
    },
    "uploadFromDeviceHelp": "Use your own image or MP4 video — no AI credits required.",
    "uploadCreativeLabel": "Campaign creative",
    "uploadCreativeHelp": "Upload a PNG or JPG (up to 3 MB) or MP4 video (up to 8 MB). 16:9 ratio recommended.",
    "uploadPosterLabel": "Poster image",
    "uploadPosterHelp": "Still image shown before the video loads and in listings.",
    "uploading": "Uploading...",
    "serviceLabel": "Service",
    "serviceHelp": "Select the service this campaign will promote",
    "servicePlaceholder": "Select a service",
    "startDateLabel": "Start date",
    "startDateHelp": "When should the campaign start showing?",
    "adPlanLabel": "Ad plan",
    "adPlanHelp": "Select the advertisement plan",
    "adPlanPlaceholder": "Select a plan",
    "next": "Next",
    "back": "Back",
    "postCreatePayHint": "Campaign created. Pay for it to submit for approval.",
    "steps": {
      "creative": "Creative",
      "service": "Service & plan",
      "review": "Review"
    },
    "errors": {
      "waitUpload": "Please wait for upload to complete",
      "uploadFailed": "Upload failed",
      "imageRequired": "Campaign image is required",
      "videoRequired": "Campaign video is required",
      "posterRequired": "Poster image is required for video ads",
      "selectService": "Please select a service",
      "selectPlan": "Please select an ad plan",
      "startDateRequired": "Start date is required",
      "selectBusiness": "Select a business for this campaign",
      "createFailed": "Failed to create campaign"
    },
    "toasts": {
      "createdSuccess": "Campaign created successfully"
    },
    "uploadingProgress": "Uploading… {{progress}}%",
    "currentCreativeLabel": "Current creative",
    "currentCreativeImage": "Still image ready for this campaign.",
    "currentCreativeVideo": "Motion ad ready for this campaign.",
    "removeCreative": "Remove"
  },
  "show": {
    "title": "Campaign Details",
    "notFoundTitle": "Campaign Not Found",
    "invalidId": "Invalid campaign ID",
    "campaignNotFound": "Campaign not found.",
    "backToCampaigns": "Back to campaigns",
    "description": "Review campaign performance and assets",
    "service": "Service",
    "startDate": "Start date",
    "endDate": "End date",
    "creativeAlt": "Campaign creative",
    "uploading": "Uploading...",
    "rejectionReason": "Rejection reason",
    "payoutStatus": "Payout",
    "payoutPaid": "Revenue paid out to business",
    "metrics": {
      "views": "Views",
      "viewsDesc": "Number of views over time",
      "clicks": "Clicks",
      "clicksDesc": "Number of clicks over time",
      "ctr": "Click-through rate"
    },
    "status": {
      "running": "Running",
      "ended": "Ended",
      "awaitingApproval": "Awaiting approval",
      "awaitingPayment": "Awaiting payment"
    },
    "payment": {
      "confirmed": "Campaign payment confirmed",
      "processing": "Payment may still be processing. Refresh this page shortly.",
      "failedUrl": "Failed to get payment URL",
      "failedPay": "Failed to pay for campaign"
    },
    "image": {
      "updatedSuccess": "Image updated successfully",
      "updateFailed": "Failed to update image",
      "confirmTitle": "Update campaign image?",
      "confirmDescription": "Changing the image resets approval. Your campaign will need to be reviewed again.",
      "confirmAction": "Update image"
    },
    "creativeUnavailable": "Creative unavailable"
  },
  "edit": {
    "title": "Edit Campaign",
    "description": "Update the campaign creative",
    "detailsTitle": "Campaign details",
    "detailsDescription": "Edit name, schedule, and plan before payment.",
    "saveDetails": "Save details",
    "cardTitle": "Campaign Image",
    "cardDescription": "Upload a new image for your campaign (16:9 ratio recommended)",
    "creativeLabel": "Campaign creative",
    "creativeHelp": "Replace the current campaign image",
    "paidDetailsHint": "Details cannot be changed after payment. You can still replace the campaign image.",
    "saveChanges": "Save changes",
    "reviewDescription": "Review your changes before saving.",
    "toasts": {
      "updatedSuccess": "Campaign updated successfully",
      "updateFailed": "Failed to update campaign"
    }
  },
  "chart": {
    "selectRange": "Select range",
    "daily": "Daily",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "value": "Value"
  },
  "admin": {
    "pendingTitle": "Pending Ad Campaigns",
    "pendingDescription": "Paid campaigns awaiting approval",
    "summaryPending": "Pending",
    "summaryActive": "Active",
    "summaryRevenue": "Revenue this month",
    "review": "Review",
    "approve": "Approve",
    "reject": "Reject",
    "rejectionReasonLabel": "Rejection reason",
    "auditLog": "Audit log"
  },
  "aiCredits": {
    "imageBalance": "{{count}} image credits · GHS {{price}} each",
    "motionBalance": "{{count}} motion credits · GHS {{price}} each",
    "buyImageTitle": "Buy image credits",
    "buyMotionTitle": "Buy motion credits",
    "buyImageDescription": "Image credits are spent when you generate still ads with AI—one credit per variant you request.",
    "buyMotionDescription": "Motion credits are spent when you generate motion ads with AI—one credit per variant you request.",
    "quantityLabel": "Quantity",
    "decreaseQuantity": "Decrease quantity",
    "increaseQuantity": "Increase quantity",
    "totalCostLabel": "Total",
    "totalCost": "GHS {{total}}",
    "costBreakdown": "{{quantity}} credits × GHS {{price}} each",
    "priceUnavailable": "Price unavailable. Try again shortly.",
    "buyButton": "Pay with Paystack",
    "buyImageCredits": "Buy image credits",
    "purchaseImageCredits": "Purchase image credits",
    "purchaseMotionCredits": "Purchase motion credits",
    "buyMotionCredits": "Buy motion credits",
    "purchaseSuccess": "Credits added to your balance",
    "purchaseProcessing": "Payment may still be processing. Refresh shortly.",
    "purchaseFailed": "Failed to start credit purchase",
    "referenceLabel": "Reference image (optional)",
    "referenceHelp": "Upload a product photo or logo to redesign or animate with AI",
    "referenceReady": "Reference uploaded",
    "referenceUploadFailed": "Failed to upload reference image",
    "imagePanelTitle": "Generate still ad",
    "motionPanelTitle": "Generate motion ad",
    "headlineLabel": "Headline",
    "styleLabel": "Style notes",
    "promptLabel": "Prompt",
    "promptHelp": "Describe the ad you want. Include offer, tone, and audience.",
    "motionPromptLabel": "Motion prompt",
    "motionPromptHelp": "Describe subtle motion (zoom, shimmer, product movement).",
    "motionDefaultPrompt": "Subtle promotional motion, loop-friendly, professional ad feel",
    "motionDurationHint": "Generates a 5 second silent MP4 loop for the carousel.",
    "variantCountLabel": "Variants",
    "generateImage": "Generate with AI",
    "generateMotion": "Generate motion ad",
    "generating": "Generating…",
    "generatingMotion": "Generating video…",
    "generationFailed": "Generation failed",
    "variantAlt": "Variant {{index}}",
    "variantSelected": "Creative selected",
    "motionSelected": "Motion ad selected",
    "uploadSelectedFailed": "Failed to save selected creative",
    "animateThis": "Animate this still",
    "sourcePreviewAlt": "Source image for motion",
    "mediaTypeImage": "Image",
    "mediaTypeMotion": "Video",
    "generatingHint": "Creating your variants. This usually takes under a minute.",
    "motionGeneratingHint": "Rendering your video. This can take a few minutes — keep this tab open.",
    "selectVariantHint": "Pick a variant to use it as your ad creative.",
    "selectMotionHint": "Pick a variant to use it as your motion ad.",
    "selectedBadge": "Selected",
    "savingVariant": "Saving…",
    "savingMotion": "Saving video…",
    "preparingAnimate": "Preparing…",
    "sourceUnavailable": "Source preview unavailable. Generate or upload the still again.",
    "generationTimeout": "Generation timed out. Please try again — it can take a few minutes."
  },
  "composer": {
    "title": "Create your ad creative",
    "subtitle": "Start from a template, describe what you want, or upload your own.",
    "placeholder": "Describe the ad you want. Include the offer, tone, and audience.",
    "motionPlaceholder": "Describe the motion you want — zoom, shimmer, product movement.",
    "generate": "Generate",
    "attach": "Add a file",
    "uploadOwn": "Upload my own ad",
    "addReference": "Add reference image",
    "variants": "{{count}} variant",
    "variants_other": "{{count}} variants",
    "addDetails": "Add headline & style",
    "hideDetails": "Hide headline & style",
    "startOver": "Start over",
    "outOfImageCredits": "You're out of image credits. Buy more to generate, or upload your own ad.",
    "outOfMotionCredits": "You're out of motion credits. Buy more to generate, or upload your own ad."
  },
  "templates": {
    "productShowcase": {
      "title": "Product showcase",
      "prompt": "A clean studio shot of the product on a soft-lit pedestal, generous negative space for the offer text, premium and modern.",
      "style": "Studio lighting, minimal, high contrast",
      "motionPrompt": "A slow push-in on the product with a soft light sweeping across the surface, calm and premium, loop-friendly."
    },
    "foodDrink": {
      "title": "Food & drink",
      "prompt": "An appetising overhead shot of the dish, fresh ingredients around the plate, warm natural light, space at the top for a headline.",
      "style": "Warm, appetising, natural light",
      "motionPrompt": "Gentle steam rising and a slow drift across the table, warm and inviting, loop-friendly."
    },
    "flashSale": {
      "title": "Flash sale",
      "prompt": "A bold promotional banner announcing a limited-time discount, large percentage figure, energetic colours, clear call to action.",
      "style": "Bold, high energy, strong colour blocking",
      "motionPrompt": "A quick light sweep across the bags with a subtle bounce, energetic and attention-grabbing."
    },
    "beautySalon": {
      "title": "Beauty & salon",
      "prompt": "An elegant beauty advert with a soft gradient backdrop, polished styling, calm and premium mood, space for the salon name.",
      "style": "Soft, elegant, pastel gradient",
      "motionPrompt": "A soft shimmer travelling across the glass with a slow drift, calm and elegant, loop-friendly."
    },
    "servicePromo": {
      "title": "Book a service",
      "prompt": "A friendly advert promoting an easy online booking, calm and trustworthy tone, clear space for the service name and a call to action.",
      "style": "Clean, friendly, professional",
      "motionPrompt": "A slow pan across the tools with softly shifting light, steady and reassuring."
    },
    "tattooStudio": {
      "title": "Tattoo & studio",
      "prompt": "A warm studio advert showing skilled work in progress, natural window light on exposed brick, authentic and inviting, space for the studio name.",
      "style": "Warm, natural light, authentic documentary feel",
      "motionPrompt": "A slow drift across the studio with softly shifting light, warm and unhurried, loop-friendly."
    },
    "healthWellness": {
      "title": "Health & wellness",
      "prompt": "A calm, premium wellness advert with a clean clinical feel, soft gold accents on a dark backdrop, generous space for the offer.",
      "style": "Premium, clean, soft gold on dark",
      "motionPrompt": "A slow drifting reveal with fine gold particles and a gentle rotation, calm and premium, loop-friendly."
    },
    "logoReveal": {
      "title": "Logo reveal",
      "prompt": "Subtle motion revealing the brand mark: a gentle zoom with soft light sweeping across, loop-friendly, professional ad feel.",
      "style": "",
      "motionPrompt": "Subtle motion revealing the brand mark: a gentle zoom with soft light sweeping across, loop-friendly, professional ad feel."
    }
  }
}
